var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditNewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26547_20094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15253 1.77784C9.28964 1.6158 9.45925 1.48391 9.65055 1.39057C9.84184 1.29722 10.0506 1.24448 10.2636 1.23569C10.4765 1.2269 10.689 1.26227 10.8874 1.33953C11.0859 1.41679 11.2659 1.53426 11.4161 1.68444C11.5663 1.83462 11.6833 2.01423 11.7597 2.21181C11.8361 2.40938 11.8702 2.6206 11.8599 2.832C11.8495 3.0434 11.7949 3.25033 11.6996 3.43962C11.6043 3.62891 11.4702 3.79639 11.3061 3.9314L4.03781 11.1997L1.07666 12.0073L1.88425 9.04612L9.15253 1.77784Z",
    stroke: "black",
    strokeWidth: 0.942185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07617 2.85156L10.2297 5.00513",
    stroke: "black",
    strokeWidth: 0.942185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26547_20094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9214,
    height: 12.9214,
    fill: "white",
    transform: "translate(0 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNewIcon);
export default __webpack_public_path__ + "static/media/EditNewIcon.224af2781250cbd35f922d2b9b9749dc.svg";
export { ForwardRef as ReactComponent };